classOddEven = function() {

    var self = this;

    this.x = 0;
    this.y = 0;

    this.setX = function(x) {
        self.x = x;
        return self;
    }

    this.setY = function(y) {
        self.y = y;
        return self;
    }

    this.appendOdd = function() {


        var obj = new classImage()
                .setX(self.x)
                .setY(self.y)
                .setAnimation({
                    show: true,
                    stop: false,
                    sequences: images[mode + '_check_infobar'],
                    speed: 4,
                });

        obj.hookAfterDraw = function() {
            if (obj.drawer.sequenceNo == obj.animation.sequences.length - 1) {
                obj.stopAnimation();
            }

        }

        scene.add(
                obj,
                'odd_' + drawnOddBalls
                );
    }

    this.appendEven = function() {

        var obj = new classImage()
                .setX(self.x)
                .setY(self.y)
                .setAnimation({
                    show: true,
                    stop: false,
                    sequences: images[mode + '_check_infobar'],
                    speed: 4,
                });

        obj.hookAfterDraw = function() {
            if (obj.drawer.sequenceNo == obj.animation.sequences.length - 1) {
                obj.stopAnimation();
            }

        }

        scene.add(
                obj,
                'even_' + drawnEvenBalls
                );
    }
}

classColorBetting = function() {

    var self = this;

    this.x = 0;
    this.y = 0;

    this.setX = function(x) {
        self.x = x;
        return self;
    }

    this.setY = function(y) {
        self.y = y;
        return self;
    }

    this.append = function(color) {

        var obj = new classImage(images['color_betting_' + color])
                .setX(self.x)
                .setY(self.y);

        scene.add(
                obj,
                'color_betting_image_' + shownColorBetting
                );
        
        shownColorBetting = shownColorBetting + 1;
    }


}


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/js/infobar.js
// module id = 845
// module chunks = 2